// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file rubykaigi/sponsor_app/admin_expense_reports.proto (package rubykaigi.sponsor_app, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { ExpenseReportReview_Action } from "./expense_report_pb";
import { file_rubykaigi_sponsor_app_expense_report } from "./expense_report_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file rubykaigi/sponsor_app/admin_expense_reports.proto.
 */
export const file_rubykaigi_sponsor_app_admin_expense_reports: GenFile = /*@__PURE__*/
  fileDesc("CjFydWJ5a2FpZ2kvc3BvbnNvcl9hcHAvYWRtaW5fZXhwZW5zZV9yZXBvcnRzLnByb3RvEhVydWJ5a2FpZ2kuc3BvbnNvcl9hcHAijAEKGEV4cGVuc2VSZXBvcnRSZXZpZXdJbnB1dBJOCgZhY3Rpb24YASABKA4yMS5ydWJ5a2FpZ2kuc3BvbnNvcl9hcHAuRXhwZW5zZVJlcG9ydFJldmlldy5BY3Rpb25CC7pICMgBAYIBAhABEhQKB2NvbW1lbnQYAiABKAlIAIgBAUIKCghfY29tbWVudEIR6gIOUms6OlNwb25zb3JBcHBiBnByb3RvMw", [file_buf_validate_validate, file_rubykaigi_sponsor_app_expense_report]);

/**
 * The verdict on an expense report's latest submission, taken by
 * AdminService.CreateExpenseReportReview.
 *
 * @generated from message rubykaigi.sponsor_app.ExpenseReportReviewInput
 */
export type ExpenseReportReviewInput = Message<"rubykaigi.sponsor_app.ExpenseReportReviewInput"> & {
  /**
   * The verdict.
   *
   * @generated from field: rubykaigi.sponsor_app.ExpenseReportReview.Action action = 1;
   */
  action: ExpenseReportReview_Action;

  /**
   * What to tell the sponsor. A rejection without one is answered `invalid_argument` with
   * PROBLEM_TYPE_INVALID_RECORD.
   *
   * @generated from field: optional string comment = 2;
   */
  comment?: string | undefined;
};

/**
 * Describes the message rubykaigi.sponsor_app.ExpenseReportReviewInput.
 * Use `create(ExpenseReportReviewInputSchema)` to create a new message.
 */
export const ExpenseReportReviewInputSchema: GenMessage<ExpenseReportReviewInput> = /*@__PURE__*/
  messageDesc(file_rubykaigi_sponsor_app_admin_expense_reports, 0);

